import { render } from "./PostCard.vue?vue&type=template&id=ab8e8a38"
import script from "./PostCard.vue?vue&type=script&lang=js"
export * from "./PostCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__